import React from 'react'

const Footer = () => {

    return (
        <footer class="   bg-[#111] text-[#757575] px-[0] py-[20px] text-center">
            <div class="mt-16 max-w-[1200px] mx-[auto] my-[0] px-[20px] py-[0] flex flex-wrap justify-between items-center">
                <div class="footer-links">
                    <ul class="list-none p-0 m-0 text-left">
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">FAQ</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Help Center</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Account</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Media Center</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Investor Relations</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Jobs</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Ways to Watch</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Terms of Use</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Privacy</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Cookie Preferences</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Corporate Information</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Contact Us</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Speed Test</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Legal Notices</a></li>
                        <li className='inline mr-[10px]'><a href="#" class="text-[#757575] no-underline hover:text-[#fff]">Only on Netflix</a></li>
                    </ul>
                </div>
                <div class=" copyright mt-3">
                    <p>&copy; 2024 Netflix Clone. All rights reserved.</p>
                </div>
            </div>
        </footer>

    )
}

export default Footer